import { render, staticRenderFns } from "./MilkVatChartsTab.vue?vue&type=template&id=67bcd0ac&"
import script from "./MilkVatChartsTab.vue?vue&type=script&lang=ts&"
export * from "./MilkVatChartsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports